import { Injectable } from '@angular/core';
import { HttpProviderService } from '@fpx/common/services';
@Injectable({
  providedIn: 'root',
})
export class BaseFpxService {
  constructor(private _httpProvider: HttpProviderService) {}
}
